export default {
  name: `rotate_screen`,
  cta: `画面を回転させてください`,
};
